// Stable icon paths with ?v= cache bust (immutable nginx cache).
// Override VITE_ICON_VERSION in Program/.env or Cloud Build (_VITE_ICON_VERSION).

const resolveIconVersion = (): string => {
  const fromEnv =
    typeof import.meta.env.VITE_ICON_VERSION === 'string'
      ? import.meta.env.VITE_ICON_VERSION.trim()
      : '';
  if (fromEnv.length > 0) {
    return fromEnv;
  }
  return '2026-07-20';
};

const iconVersion = resolveIconVersion();

export const iconUrl = (path: string): string => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${normalized}?v=${encodeURIComponent(iconVersion)}`;
};

export const APP_ICONS = {
  menu: iconUrl('/icons/icon-menu.png'),
  any192: iconUrl('/icons/icon-192-any.png'),
  any512: iconUrl('/icons/icon-512-any.png'),
  maskable192: iconUrl('/icons/icon-192-maskable.png'),
  maskable512: iconUrl('/icons/icon-512-maskable.png'),
  appleTouch: iconUrl('/icons/apple-touch-icon.png'),
  pushBadge: iconUrl('/icons/icon-push-badge.png'),
} as const;
